<template>
  <!-- 大件订单看板————柱状图 -->
  <div id="barChart" style="width: 100%; height: 400px;" />
</template>

<script>
import * as echarts from 'echarts';
export default {
  props: {
    options: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      barChart: null
    };
  },
  watch: {
    options: {
      handler(val) {
        this.barChart.setOption(val, true);
      },
      deep: true
    }
  },
  mounted() {
    this.initBarChart();
    window.addEventListener('resize', this.resizeHandler);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    initBarChart() {
      const chartDom = document.getElementById('barChart');
      this.barChart = echarts.init(chartDom);

      const option = this.options;
      this.barChart.setOption(option);
    },
    resizeHandler() {
      if (this.barChart) {
        this.barChart.resize();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
